<template>
  <div class="theme-transition">
    <AppHeader variant="transparent" show-mission-and-blog="true" />
    <main>
      <HeroSection />

      <div class="bg-surfaceSaturated">
        <PlatformSection
          image-src="/images/transport-logistics-concept-2-1.png"
          image-webp="/images/transport-logistics-concept-2-1.webp"
          image-avif="/images/transport-logistics-concept-2-1.avif"
          :image-alt="$t('landing.logisticsImageAlt')"
          :title="$t('landing.logisticsTitle')"
          :description="$t('landing.logisticsDescription')"
          :cta-text="$t('landing.logisticsCtaText')"
          cta-link="/services-search"
          rounded
        />

        <PlatformSection
          image-src="/images/interior-large-distribution-warehouse-with-shelves-stacked-with-.png"
          image-webp="/images/interior-large-distribution-warehouse-with-shelves-stacked-with-.webp"
          image-avif="/images/interior-large-distribution-warehouse-with-shelves-stacked-with-.avif"
          :image-alt="$t('landing.warehouseImageAlt')"
          :title="$t('landing.warehouseTitle')"
          :description="$t('landing.warehouseDescription')"
          :cta-text="$t('landing.warehouseCtaText')"
          cta-link="#"
          reverse
          class="pb-20"
          disabled
        />
      </div>

      <div class="bg-background">
        <MissionSection />
      </div>
      <ClientsSection />

      <div class="bg-surfaceSaturated">
        <BlogSection />
      </div>
    </main>
    <div class="bg-background">
      <AppFooter class="rounded-t-3xl" />
    </div>
  </div>
</template>

<script>
import AppHeader from "../common/Header.vue";
import AppFooter from "../common/Footer.vue";
import HeroSection from "./HeroSection.vue";
import PlatformSection from "./PlatformSection.vue";
import ClientsSection from "./ClientsSection.vue";
import MissionSection from "./MissionSection.vue";
import BlogSection from "./BlogSection.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    HeroSection,
    PlatformSection,
    ClientsSection,
    MissionSection,
    BlogSection,
  },
};
</script>

<style scoped></style>
